module.exports = __webpack_public_path__ + "media/images/discover/offers/digital-voucher@2x-1f7c05021bf1a48b2dd3e33129bd4bb2.jpg";